export const services = [
  {
    id: 'local-moving',
    icon: 'ri-map-pin-2-line',
    title: 'Local Moving',
    description: 'Efficient, careful local moves throughout Minneapolis and the Twin Cities metro area with no hidden fees.',
    detail: 'We handle every detail of your local move — from careful packing and secure loading to precise placement in your new home.',
  },
  {
    id: 'residential-moving',
    icon: 'ri-home-4-line',
    title: 'Residential Moving',
    description: 'Full-service home moving with experienced movers who treat your belongings like their own.',
    detail: 'Your home move is personal. Our residential moving team brings care, precision, and decades of experience to every job.',
  },
  {
    id: 'apartment-moving',
    icon: 'ri-building-2-line',
    title: 'Apartment Moving',
    description: 'Specialists in apartment moves — narrow hallways, elevators, and tight turns are no problem for our team.',
    detail: 'Minneapolis apartment moves require skill and experience. We navigate complex buildings with ease so you don\'t have to worry.',
  },
  {
    id: 'house-moving',
    icon: 'ri-community-line',
    title: 'House Moving',
    description: 'Comprehensive house-to-house moves with full care for furniture, appliances, and all your valuables.',
    detail: 'From a starter home to a large estate, our house moving service delivers seamless, stress-free relocation across the Twin Cities.',
  },
  {
    id: 'commercial-moving',
    icon: 'ri-store-2-line',
    title: 'Commercial Moving',
    description: 'Minimize business downtime with our strategic commercial moving solutions for offices and businesses.',
    detail: 'We plan, coordinate, and execute commercial moves with minimal disruption so your business gets back to work fast.',
  },
  {
    id: 'full-service-moving',
    icon: 'ri-service-line',
    title: 'Full-Service Moving',
    description: 'We handle everything — packing, loading, transport, unloading, and furniture setup at your new place.',
    detail: 'The ultimate hands-off move. We take care of every detail from start to finish so you can focus on what matters.',
  },
  {
    id: 'heavy-item-moving',
    icon: 'ri-shield-check-line',
    title: 'Heavy-Item Moving',
    description: 'Pianos, safes, gym equipment, and oversized furniture moved safely with professional equipment and training.',
    detail: 'Heavy and specialty items require the right tools and expertise. Our team is trained and equipped for every challenge.',
  },
  {
    id: 'last-minute-moving',
    icon: 'ri-timer-flash-line',
    title: 'Last-Minute Moving',
    description: 'Need to move fast? We offer rapid-response scheduling for urgent moves throughout the Minneapolis area.',
    detail: 'Life doesn\'t always give you time to plan. When you need movers today, TrueCare delivers fast, reliable emergency moving service.',
  },
  {
    id: 'loading-unloading',
    icon: 'ri-loader-4-line',
    title: 'Loading & Unloading',
    description: 'Labor-only loading and unloading service — perfect for rental trucks, containers, and storage units.',
    detail: 'Already have a truck? Let our strong, experienced team handle the hard work of loading and unloading safely.',
  },
];

export const processSteps = [
  {
    step: '01',
    title: 'Request a Quote',
    description: 'Fill out our simple form or call us. We\'ll provide a transparent, no-obligation estimate tailored to your move.',
    icon: 'ri-file-list-3-line',
  },
  {
    step: '02',
    title: 'Plan Your Move',
    description: 'We coordinate your move date, review logistics, and prepare a custom plan to ensure a smooth transition.',
    icon: 'ri-calendar-check-line',
  },
  {
    step: '03',
    title: 'Packing & Prep',
    description: 'Our professional team packs and protects your belongings with quality materials and expert wrapping techniques.',
    icon: 'ri-archive-line',
  },
  {
    step: '04',
    title: 'Safe Transport',
    description: 'We load everything securely into our clean, well-maintained trucks and transport your items with the utmost care.',
    icon: 'ri-truck-line',
  },
  {
    step: '05',
    title: 'Delivery & Setup',
    description: 'We unload, place furniture exactly where you want it, and ensure you\'re fully settled before we leave.',
    icon: 'ri-home-heart-line',
  },
];

export const trustBadges = [
  { icon: 'ri-shield-check-line', label: 'Licensed & Insured', value: 'Fully Protected' },
  { icon: 'ri-heart-line', label: 'Family-Owned', value: 'Since 2015' },
  { icon: 'ri-award-line', label: 'A+ BBB Rated', value: 'Top Rated' },
  { icon: 'ri-star-fill', label: '5-Star Reviews', value: 'Google Verified' },
  { icon: 'ri-timer-2-line', label: '10+ Years', value: 'In Business' },
  { icon: 'ri-bank-card-line', label: 'No Hidden Fees', value: 'Transparent Pricing' },
  { icon: 'ri-thumb-up-line', label: '231 Google Reviews', value: '5-Star Average' },
];

export const testimonials = [
  {
    name: 'Sarah M.',
    location: 'Minneapolis, MN',
    rating: 5,
    text: 'Absolutely incredible experience. The TrueCare team showed up on time, worked with speed and precision, and treated every item like it was priceless. My apartment move was flawless — not a scratch on anything. Highly recommend to anyone moving in Minneapolis.',
    tag: 'Apartment Move',
  },
  {
    name: 'James T.',
    location: 'Eagan, MN',
    rating: 5,
    text: 'We moved from a large home in Eagan to Eden Prairie. The crew was professional, efficient, and friendly the entire time. Pricing was transparent — exactly what was quoted. No surprises. Best moving company we\'ve ever used.',
    tag: 'House Move',
  },
  {
    name: 'Priya K.',
    location: 'Bloomington, MN',
    rating: 5,
    text: 'I called TrueCare for a last-minute move and they made it happen within 24 hours. The team arrived prepared, worked incredibly fast, and were respectful of our home. Communication was excellent throughout. I\'m genuinely impressed.',
    tag: 'Last-Minute Move',
  },
  {
    name: 'David R.',
    location: 'Maple Grove, MN',
    rating: 5,
    text: 'Hired TrueCare to move our office — five rooms of furniture and tech equipment. Zero downtime. They had everything organized and placed perfectly in our new space by noon. This team is a true professional operation.',
    tag: 'Commercial Move',
  },
  {
    name: 'Michelle L.',
    location: 'St. Paul, MN',
    rating: 5,
    text: 'They moved my piano and two heavy safes with zero issues. I was worried, but the crew brought proper equipment and handled everything safely. Pricing was completely fair. Will absolutely use TrueCare again for our next move.',
    tag: 'Heavy-Item Move',
  },
  {
    name: 'Kevin & Amy N.',
    location: 'Plymouth, MN',
    rating: 5,
    text: 'From the initial quote call to the final box being set down — TrueCare was exceptional. They were communicative, punctual, careful with our belongings, and genuinely kind people. The best moving experience we\'ve ever had. Period.',
    tag: 'Full-Service Move',
  },
];

export const stats = [
  { value: '10+', label: 'Years in Business', icon: 'ri-history-line' },
  { value: '231', label: 'Google Reviews', icon: 'ri-star-fill' },
  { value: '500+', label: 'Moves Completed', icon: 'ri-truck-line' },
  { value: '5★', label: 'Average Rating', icon: 'ri-award-line' },
];

export const serviceAreas = [
  'Minneapolis', 'St. Paul', 'Bloomington', 'Plymouth',
  'Woodbury', 'Lakeville', 'Blaine', 'Maple Grove',
  'Eagan', 'Eden Prairie', 'Burnsville', 'Coon Rapids',
  'St. Louis Park', 'Minnetonka', 'Edina', 'Apple Valley',
  'Shakopee', 'Maplewood', 'Cottage Grove', 'Roseville',
  'Chaska', 'Oakdale', 'Shoreview', 'Brooklyn Park',
];

export const faqs = [
  {
    q: 'Who provides moving services near me in Minneapolis?',
    a: 'TrueCare Moving Services LLC provides professional moving services throughout Minneapolis and the Twin Cities metro area. We\'re a local, family-owned company licensed and insured in Minnesota, with 10+ years of experience and 231 five-star Google reviews. Call us at (612) 367-4481 for a free quote.',
  },
  {
    q: 'How much does a moving service cost in Minneapolis?',
    a: 'Moving costs vary based on move size, distance, and services needed. TrueCare Moving Services offers transparent, upfront pricing with no hidden fees. Most local Minneapolis moves range from $300–$1,200. We provide free, no-obligation estimates so you know exactly what to expect before booking.',
  },
  {
    q: 'How long does a local move take in Minneapolis?',
    a: 'A typical local Minneapolis move takes between 3 and 8 hours depending on home size and how much needs to be moved. Our efficient team works quickly and carefully to minimize your moving day stress. We\'ll give you an accurate time estimate when you request your free quote.',
  },
  {
    q: 'Do you offer apartment and commercial moving in Minneapolis?',
    a: 'Yes. TrueCare Moving Services specializes in both apartment moving and commercial moving throughout Minneapolis and the Twin Cities. We handle narrow hallways, elevators, and building logistics for apartments, and minimize downtime for business relocations with strategic commercial moving plans.',
  },
  {
    q: 'Do you provide last-minute movers in Minneapolis?',
    a: 'Absolutely. TrueCare offers rapid-response last-minute moving services throughout Minneapolis and surrounding cities. We understand that emergencies happen, and our team is ready to mobilize quickly. Call (612) 367-4481 to check same-day or next-day availability for your urgent move.',
  },
  {
    q: 'Are TrueCare movers licensed and insured in Minnesota?',
    a: 'Yes, TrueCare Moving Services LLC is fully licensed and insured in the state of Minnesota. We carry proper liability coverage for all moves, giving you peace of mind that your belongings are protected. We\'re also A+ BBB rated, family-owned, and have served Minneapolis for over 10 years.',
  },
  {
    q: 'What cities do you serve in the Twin Cities area?',
    a: 'We serve Minneapolis, St. Paul, Bloomington, Plymouth, Woodbury, Maple Grove, Eagan, Eden Prairie, Edina, Burnsville, Lakeville, Coon Rapids, Brooklyn Park, Minnetonka, St. Louis Park, Apple Valley, Shakopee, Maplewood, Roseville, and many more Twin Cities communities.',
  },
  {
    q: 'Do you help with packing and unpacking during a move?',
    a: 'Yes. TrueCare offers full-service moving which includes professional packing, wrapping, and unpacking. Our team uses quality packing materials to protect your items. You can choose full packing service, partial packing, or just moving labor — whatever fits your needs and budget.',
  },
];

export const whyChooseUs = [
  { icon: 'ri-user-star-line', title: 'Experienced Movers', description: '10+ years serving Minneapolis with a trained, background-checked team dedicated to careful handling.' },
  { icon: 'ri-time-line', title: 'Always On Time', description: 'We respect your schedule. Punctuality is a core commitment — we show up when we say we will, every time.' },
  { icon: 'ri-shield-star-line', title: 'Careful Handling', description: 'Every item is treated with the same care we\'d give our own belongings. Nothing gets left behind or damaged.' },
  { icon: 'ri-price-tag-3-line', title: 'Transparent Pricing', description: 'No hidden fees, no surprise charges. You get a clear, honest quote upfront and that\'s exactly what you pay.' },
  { icon: 'ri-map-pin-line', title: 'True Local Experts', description: 'We know Minneapolis and the Twin Cities inside out — buildings, traffic, neighborhoods, and regulations.' },
  { icon: 'ri-building-line', title: 'Residential & Commercial', description: 'From studio apartments to large office relocations — we handle every type and size of move professionally.' },
  { icon: 'ri-calendar-line', title: 'Flexible Scheduling', description: 'Available Monday–Saturday 7am–10pm. We work around your timeline, including weekends and short-notice requests.' },
  { icon: 'ri-emotion-happy-line', title: 'Stress-Free Experience', description: 'Moving is hard enough. Our job is to make it easy. We take the weight off your shoulders — literally.' },
];
